import { ScrollSpy, ScrollSpyItem } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';

import { InsightsLivePrice } from '~/components/insights-live-price/InsightsLivePrice';

import * as S from './Sidebar.styles';

export const Sidebar = ({
  entityData,
  containerRef,
  items,
}: {
  entityData: Entity;
  containerRef: React.RefObject<HTMLElement | null>;
  items: ScrollSpyItem[];
}) => {
  return (
    <S.SidebarContainer>
      <S.LivePriceWrapper>
        <InsightsLivePrice entity={entityData} />
      </S.LivePriceWrapper>
      <ScrollSpy items={items} containerRef={containerRef} />
    </S.SidebarContainer>
  );
};
